import type { SVGProps } from "react";

export const UserDownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M19 18V14H17V18H15L18 21L21 18H19ZM11 4C8.8 4 7 5.8 7 8C7 10.2 8.8 12 11 12C13.2 12 15 10.2 15 8C15 5.8 13.2 4 11 4ZM11 6C12.1 6 13 6.9 13 8C13 9.1 12.1 10 11 10C9.9 10 9 9.1 9 8C9 6.9 9.9 6 11 6ZM11 13C8.3 13 3 14.3 3 17V20H12.5C12.2 19.4 12.1 18.8 12 18.1H4.9V17C4.9 16.4 8 14.9 11 14.9C11.5 14.9 12 15 12.5 15C12.8 14.4 13.1 13.8 13.6 13.3C12.6 13.1 11.7 13 11 13Z"
      fill="#C1C7CE"
    />
  </svg>
);
